export default __webpack_public_path__ + "static/media/banner-image-4.2541024e.JPG";